export interface createSimultaneousRequestsOptions {
    maxConcurrentRequests: number;
}
export async function createSimultaneousRequests<I, R>(
    requestArg: I[],
    asyncFn: (I) => Promise<R>,
    options?: Partial<createSimultaneousRequestsOptions>,
): Promise<R[]> {
    const { maxConcurrentRequests = 5 } = options || {};
    const results: R[] = [];
    const runAsyncAndRunAgain = async (currentIndex: number) => {
        if (requestArg[currentIndex]) {
            const result = await asyncFn(requestArg[currentIndex]);
            results.push(result);
            return runAsyncAndRunAgain(currentIndex + maxConcurrentRequests);
        }
    };

    const promises: Promise<void>[] = [];
    for (let i = 0; i < maxConcurrentRequests; i++) {
        promises.push(runAsyncAndRunAgain(i));
    }

    await Promise.all(promises);
    return results;
}
